<template>
  <h2 class="heading">System-based Authorization</h2>
  <div style="width: 95%; margin:5px auto;height:35px;">
    <span style="padding:0px 12px;color:#888;">System:</span>
    <el-select v-model="system" class="m-2" placeholder="Select System" @change="selectSystem()" style="width:300px;">
        <el-option v-for="system in allSystems" :key="system" :label="system" :value="system">
        </el-option>
    </el-select>
    <el-button style="margin-left:20px;" @click="saveAuthorization" type="primary">Save Authorization</el-button>
    <span v-if="loading" style="display:inline-block; margin-left:20px; vertical-align:middle;">
        <img src="@/assets/loading.gif" style="height:24px;"/>
    </span>
    <span v-if="success" class="successMsg">Saved authorization successfully!</span>
    <el-alert :title="errMsg" type="error" show-icon v-if="errMsg != ''"></el-alert>
    <el-button style="margin-left:20px;float:right" @click="$router.push('userList')">All Users</el-button>

    <el-button style="float:right" @click="$router.push('authorizeByUser')">User-based Authorization</el-button>
  </div>

  <el-table :data="userRoles" stripe="true" height="95%" style="width: 95%; margin:15px auto;">
    <el-table-column prop="user" label="User" width="200"/>
    <el-table-column v-for="(role, index) in roles" :key="index" :prop="role" :label="role" align="center">
        <template #default="scope">
            <el-icon :size="20"  v-if="scope.row[role]" @click="scope.row[role]=false" >
                <CircleCheckFilled />
            </el-icon>
            <el-icon :size="20" v-else @click="scope.row[role]=true" >
                <CircleCheck style="color:#ccc;" />
            </el-icon>
        </template>
    </el-table-column>
  </el-table>

</template>

<script>
import { CircleCheckFilled, CircleCheck } from '@element-plus/icons-vue'
import AXIOS from '@/common/axios.js'
import global from '@/common/global.js'

export default {
    components: {
        CircleCheckFilled, CircleCheck
    },
    data() {
        return {
            system: null,
            allSystems: [],
            userRoles: [],
            roles: [],
            errMsg: '',
            success: false,
            loading: false,
            global,
        }
    },
    async created() {
        this.global.index = "auth";
        let result = await AXIOS("/auth/getAllSystems");
        this.errMsg = '';
        if (result.success) {
            this.allSystems = result.data;
        } else {
            this.errMsg = result.errMsg;
        }
        this.selectSystem();
    },

    methods: {
        async selectSystem() {
            this.errMsg = '';
            let data = this.system ? {system: this.system} : {};
            let result = await AXIOS("/auth/getUserRolesBySystem", data);
            if (result.success) {
                this.userRoles = result.data.userRoles;
                this.roles = result.data.roles;
                this.system = result.data.system;
            } else {
                this.errMsg = result.errMsg;
            }
        },

        async saveAuthorization() {
            this.success = false;
            this.errMsg = '';
            if (this.system == null) {
                this.errMsg = "Please select system first";
                return;
            }
            let checkedRoles = '';
            for (var i = 0; i < this.userRoles.length; i++) {
                let obj = this.userRoles[i];
                let userId = obj.userId;
                for (var j = 0; j < this.roles.length; j++) {
                    let role = this.roles[j];
                    if (obj[role]) {
                        checkedRoles += role+"@"+userId + ";";
                    }
                }
            }
            if (checkedRoles.length > 0) {
                checkedRoles = checkedRoles.substring(0, checkedRoles.length-1);
            }
            console.log(checkedRoles);

            let data = {system: this.system, checkedRoles: checkedRoles };
            this.loading = true;
            let result = await AXIOS("/auth/saveAuthorization2", data);
            if (result.success) {
                this.success = true;
            } else {
                this.errMsg = result.errMsg;
            }
            this.loading = false;
        }
    }
}
</script>

<style scoped>
    .heading {
        text-align:center;
        color:#01b1af;
        font-family: Arial, Helvetica, sans-serif;
    }
    .el-table .el-icon {
        margin: 0px 3px;
        color: #409eff;
    }
    .role {
        color:#AAA;
        margin-right:20px;
        cursor:pointer;
    }
    span.active {
        color:#409eff;
        font-weight:bold;
    }
    .errMsg {
        color:#F56C6C;
        padding-left:20px;
    }
    .successMsg {
        color:#67C23A;
        padding-left:20px;
    }
</style>